/**
 * A traffic partner that sends its users to a tenant: Shift and OneLaunch on
 * Discover today. Its id goes to AY custom_11 and to the `_partner` cookie,
 * which qz.com articles read on the same host. Both partners run on the
 * tenant's own ad widgets; custom_11 splits their revenue.
 */
export type PartnerId = 'shift' | 'onelaunch'

// Each id is also the partner's window.chrome key and its utm_source. Checked
// in this order. A new partner is an id here and in duplex-quartz's
// src/services/partner, plus its custom_11 value on the AY Custom Dimensions page.
export const PARTNER_IDS: readonly PartnerId[] = ['shift', 'onelaunch']

export function isPartnerId(value: unknown): value is PartnerId {
  return PARTNER_IDS.some((id) => id === value)
}
